export const headerText = "You can chat in any language, and we will translate it automatically.";
export const welcomeText = "Welcome to the Online Help Center!";
export const placeholderText = "Type your message...";
export const initializingText = "Initializing... please wait";
export const buttonText = "Send";
export const duplicateConnectionText = "It seems that you are already connected to support chat. Connection closed.";
export const connectionFailedText = "Support chat connection failed. Please try again later!";
export const userNickText = "You";
export const supportNickSuffix = "Customer Support";
export const typingText = "Support is typing...";
export const userKickedText = "Disconnected by admin";
const translations = {
    headerText,
    welcomeText,
    placeholderText,
    initializingText,
    buttonText,
    duplicateConnectionText,
    connectionFailedText,
    userNickText,
    supportNickSuffix,
    typingText,
    userKickedText,
};
export default translations;
